export default {
  en: {
    yes: 'Yes',
    no: 'No',
    unanswered: 'Unanswered',
    notApplicable: 'Not applicable',
    invalid: 'Invalid',
    notRequired: 'Not required',
    requireYes: 'Require yes',
    outOfScope: 'Out of scope',
    answer: 'Answer',
    answered: 'Answered',
    youAnswered: 'You answered',
    editAnswer: 'Edit answer',
    lastModified: 'Last modified {0}',
    dateFormat: 'yyyy/MM/dd',
    expiry: 'When does your certification expire?',
    expired: 'Expired',
    expiredOn: 'Expired on',
    expiresOn: 'Expires on',
    expiresOnDate: 'Yes (expires on {0})',
  },
};
